import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import AuthApiService from "../../ApiServices/AuthApiService"; // adjust path as needed
import { toast } from "react-toastify";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await AuthApiService.forgotPassword({ email });

      if (response.isSuccess) {
        toast.success("Password reset link sent to your email.");
        setEmail("");
      } else {
        toast.error(response.message || "Something went wrong.");
      }
    } catch (error) {
      toast.error("Failed to send reset link. Please try again.");
      console.error("Forgot password error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ rotateY: 90, opacity: 0 }}
      animate={{ rotateY: 0, opacity: 1 }}
      transition={{ duration: 1 }}
      className="min-h-screen bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 flex items-center justify-center px-4"
    >
      <motion.div
        className="backdrop-blur-xl bg-white/10 border border-white/20 shadow-2xl rounded-3xl p-10 w-full max-w-md"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 120 }}
      >
        <div className="text-center mb-6">
          <img src="/Images/logo.png" className="h-16 mx-auto" alt="Logo" />
          <h1 className="text-3xl font-bold text-white mt-4">Forgot Password</h1>
          <p className="text-sm text-white/80">
            Enter your email and we'll send you a password reset link.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <InputWithIcon
            id="email"
            icon={faEnvelope}
            type="email"
            placeholder="Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <motion.button
            type="submit"
            disabled={loading}
            className={`w-full py-3 mt-4 bg-yellow-400 text-black rounded-xl font-bold tracking-wide hover:bg-yellow-300 transition duration-300 shadow-md ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            whileTap={{ scale: 0.95 }}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </motion.button>
        </form>

        <p className="text-sm text-white/80 text-center mt-6">
          Remembered your password?{" "}
          <Link to="/login" className="text-yellow-300 hover:underline">Back to Login</Link>
        </p>
      </motion.div>
    </motion.div>
  );
}

function InputWithIcon({ id, icon, type = "text", placeholder, value, onChange }) {
  return (
    <div className="relative">
      <label htmlFor={id} className="block text-white mb-1 capitalize">
        {placeholder}
      </label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        required
        className="w-full bg-white/20 text-white placeholder-white/70 px-11 py-3 rounded-lg border border-white/30 focus:ring-2 focus:ring-yellow-300 focus:outline-none"
        placeholder={placeholder}
      />
      <FontAwesomeIcon icon={icon} className="absolute top-1/2 left-4 transform -translate-y-1/2 text-white/80" />
    </div>
  );
}
